import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: process.env.REACT_APP_KEYCLOAK_URL || 'http://localhost:8080',
  realm: process.env.REACT_APP_KEYCLOAK_REALM || 'default',
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'client-id',
});

export default keycloak;

export const eventLogger = (event: unknown, error: unknown): void => {
  console.log('onKeycloakEvent', event, error);
};

export const tokenLogger = (tokens: unknown): void => {
  console.log('onKeycloakTokens', tokens);
};
